import React from "react";
import Tree from "react-d3-tree";

// import Tree from "react-tree-graph";
// import "react-tree-graph/dist/style.css";

import BackButton from "../../component/button/BackButton";
// import Card from "../../component/card/Card";
import LeftNav from "../../component/leftSideNav/LeftNav";
import TopBar from "../../component/topBar/TopBar";
import "./custom-tree.css";

const orgChart = {
  name: "CEO",
  children: [
    {
      name: "Manager",
      attributes: {
        department: "Production"
      },
      children: [
        {
          name: "Foreman",
          attributes: {
            department: "Fabrication"
          },
          children: [
            {
              name: "Worker"
            }
          ]
        },
        {
          name: "Foreman",
          attributes: {
            department: "Assembly"
          },
          children: [
            {
              name: "Worker"
            }
          ]
        }
      ]
    }
  ]
};

const Relation = () => {
  // const data = {
  //   name: "CMC",
  //   pathProps: {},
  //   textProps: { x: -25, y: 25 },
  //   children: [
  //     {
  //       name: "Black",
  //       pathProps: { className: "black" },
  //       textProps: { x: -25, y: 25 },
  //       children: [
  //         {
  //           name: "Aquamarine",

  //           color: "aquamarine",
  //           children: []
  //         },
  //         {
  //           name: "Cyan",

  //           color: "cyan",
  //           children: []
  //         },
  //         {
  //           name: "Navy",

  //           color: "navy",
  //           children: []
  //         },
  //         {
  //           name: "Turquoise",

  //           color: "turquoise",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "Blue",
  //       pathProps: { className: "blue" },
  //       textProps: { x: -25, y: 25 },
  //       color: "blue",
  //       children: [
  //         {
  //           name: "Aquamarine",

  //           color: "aquamarine",
  //           children: []
  //         },
  //         {
  //           name: "Cyan",

  //           color: "cyan",
  //           children: []
  //         },
  //         {
  //           name: "Navy",

  //           color: "navy",
  //           children: []
  //         },
  //         {
  //           name: "Turquoise",

  //           color: "turquoise",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "Green",
  //       pathProps: { className: "green" },
  //       textProps: { x: -25, y: 25 },
  //       color: "green",
  //       children: [
  //         {
  //           name: "Aquamarine",

  //           color: "aquamarine",
  //           children: []
  //         },
  //         {
  //           name: "Cyan",

  //           color: "cyan",
  //           children: []
  //         },
  //         {
  //           name: "Navy",

  //           color: "navy",
  //           children: []
  //         },
  //         {
  //           name: "Turquoise",

  //           color: "turquoise",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "Purple",
  //       pathProps: { className: "purple" },
  //       textProps: { x: -25, y: 25 },
  //       color: "purple",
  //       children: [
  //         {
  //           name: "Indigo",

  //           color: "indigo",
  //           children: []
  //         },
  //         {
  //           name: "Violet",

  //           color: "violet",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "Red",
  //       pathProps: { className: "red" },
  //       textProps: { x: -25, y: 25 },
  //       color: "red",
  //       children: [
  //         {
  //           name: "Crimson",

  //           color: "crimson",
  //           children: []
  //         },
  //         {
  //           name: "Maroon",

  //           color: "maroon",
  //           children: []
  //         },
  //         {
  //           name: "Scarlet",

  //           color: "scarlet",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "White",
  //       pathProps: { className: "grey" },
  //       textProps: { x: -25, y: 25 },
  //       color: "grey",
  //       children: [
  //         {
  //           name: "Aquamarine",

  //           color: "aquamarine",
  //           children: []
  //         },
  //         {
  //           name: "Cyan",

  //           color: "cyan",
  //           children: []
  //         },
  //         {
  //           name: "Navy",

  //           color: "navy",
  //           children: []
  //         },
  //         {
  //           name: "Turquoise",

  //           color: "turquoise",
  //           children: []
  //         }
  //       ]
  //     },
  //     {
  //       name: "Yellow",
  //       pathProps: { className: "yellow" },
  //       textProps: { x: -25, y: 25 },
  //       color: "yellow",
  //       children: [
  //         {
  //           name: "Aquamarine",
  //           textProps: { x: -25, y: 25 },
  //           color: "aquamarine",
  //           children: []
  //         },
  //         {
  //           name: "Cyan",
  //           textProps: { x: -25, y: 25 },
  //           color: "cyan",
  //           children: []
  //         },
  //         {
  //           name: "Navy",
  //           textProps: { x: -25, y: 25 },
  //           color: "navy",
  //           children: []
  //         },
  //         {
  //           name: "Turquoise",
  //           textProps: { x: -25, y: 25 },
  //           color: "turquoise",
  //           children: []
  //         }
  //       ]
  //     }
  //   ]
  // };

  return (
    <div className="wrapper">
      <LeftNav />
      {/* <ToastContainer /> */}
      {/* <ReactTooltip
        id="createAccess"
        place="top"
        effect="solid"
        type="info"
      >
        Click to Add Access
      </ReactTooltip> */}
      <div className="content-page">
        <TopBar title="Relations" />
        <div className="content">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1">
                <BackButton />
              </div>
              <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9"></div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2"></div>
            </div>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                {/* <Card>
                  <Tree
                    nodeRadius={15}
                    margins={{
                      top: 20,
                      bottom: 10,
                      left: 20,
                      right: 200
                    }}
                    data={data}
                    gProps={{
                      className: "node"
                      // onClick: handleClick
                    }}
                    height={700}
                    width={1080}
                  />
                </Card> */}
                <div
                  id="treeWrapper"
                  style={{ width: "1000px", height: "800px" }}
                >
                  <Tree
                    data={orgChart}
                    rootNodeClassName="node__root"
                    branchNodeClassName="node__branch"
                    leafNodeClassName="node__leaf"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Relation;
